import { BatchItemsWidget } from '../components/widgets/expense-item-summary-widget/batch-items-widget';
import { IWidgetDefinition } from '../types/widget-definition.interface';

export const ExpenseBatchItemSummaryWidgetDefinition: IWidgetDefinition = {
  component: BatchItemsWidget,
};
